import { api } from "./client";

export type Phase =
  | "prospect"
  | "in-analyse"
  | "besichtigt"
  | "angebot-raus"
  | "gekauft"
  | "abgelehnt"
  | "out";

export interface ObjektState {
  slug: string;
  phase: Phase;
  notes: string | null;
  source_url: string;
  kaufpreis_eur: number | null;
  address_short: string | null;
  last_updated: string;
}

export interface ObjekteListResponse {
  objekte: ObjektState[];
  total: number;
}

export async function listObjekte(phase?: Phase): Promise<ObjekteListResponse> {
  const { data } = await api.get<ObjekteListResponse>("/api/objekte", {
    params: phase ? { phase } : {},
  });
  return data;
}

export async function getObjekt(slug: string): Promise<ObjektState> {
  const { data } = await api.get<ObjektState>(
    `/api/objekte/${encodeURIComponent(slug)}`,
  );
  return data;
}

export async function updateObjektPhase(
  slug: string,
  phase: Phase,
  notes?: string | null,
): Promise<ObjektState> {
  const { data } = await api.patch<ObjektState>(
    `/api/objekte/${encodeURIComponent(slug)}/phase`,
    { phase, notes: notes ?? null },
  );
  return data;
}

export interface DossierSection {
  id: string;
  nr: number;
  title: string;
  markdown: string;
}

export interface DossierResponse {
  state: ObjektState;
  /** Parsed listing.json — fields are dynamic (Pydantic Inserat shape). */
  listing: Record<string, unknown> | null;
  sections: DossierSection[];
  /** Filenames of photos in the persistent volume; combine with
   * /api/objekte/{slug}/fotos/{name} for the URL. */
  photos: string[];
}

export async function getDossier(slug: string): Promise<DossierResponse> {
  const { data } = await api.get<DossierResponse>(
    `/api/objekte/${encodeURIComponent(slug)}/dossier`,
  );
  return data;
}

export type RunnableModule = "dossier";

export interface ModuleRunResponse {
  slug: string;
  module: string;
  sections: Record<string, string>;
}

export async function runModule(
  slug: string,
  module: RunnableModule,
): Promise<ModuleRunResponse> {
  const { data } = await api.post<ModuleRunResponse>(
    `/api/objekte/${encodeURIComponent(slug)}/runs/${module}`,
  );
  return data;
}
